import { Button, Modal } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { type Language } from 'src/core/config/i18n';

import howItWorksUrlDe from '../assets/how-it-works-de.png';
import howItWorksUrlEn from '../assets/how-it-works-en.png';
import howItWorksUrlFr from '../assets/how-it-works-fr.png';

import './AccountingBaseSwitchInformationModal.css';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function AccountingBaseSwitchHowItWorksModal({
  isOpen,
  onClose,
  onConfirm,
}: Props) {
  const { t, activeLanguage } = useTranslation('global');

  return (
    <Modal
      isOpen={isOpen}
      title={t('bookkeep.integrations.settings.baseSwitch.information1Title')}
      illustration={
        <div
          data-testid="accounting-base-switch-information-modal-image-container"
          className="AccountingBaseSwitchInformationModal__image-container"
        >
          <img
            className="AccountingBaseSwitchInformationModal__image"
            src={getImageUrl(activeLanguage)}
            alt={t('bookkeep.integrations.settings.baseSwitch.information1Alt')}
          />
        </div>
      }
      actions={[
        <Button
          key="back"
          variant="secondaryNeutral"
          onClick={() => onClose()}
          text={t('misc.cancel')}
        />,
        <Button
          key="confirm"
          text={t('misc.continue')}
          variant="primaryBrand"
          onClick={() => onConfirm()}
          iconName="chevron-right"
          iconPosition="right"
        />,
      ]}
    />
  );
}

const getImageUrl = (activeLanguage: Language): string => {
  switch (activeLanguage) {
    case 'fr':
      return howItWorksUrlFr;
    case 'de':
      return howItWorksUrlDe;
    default:
      return howItWorksUrlEn;
  }
};
